import { mapDateFromApi } from "src/core/utils";
import { mapPaginationFromApi } from "./paginated";
import { IEntity } from "./entity";

export interface ICotation extends IEntity{
    id: string;
    created_at: Date;
    name: string;
    product_type: string;
    user_id: string;
    user_email: string;
    enterprise_id: string;
    enterprise_name: string;
    last_updated_by: string;
    last_updated_at: Date;
    can_see_specific_payoff: boolean;
    status: string;
    category_principale: string;
    users_to_notify_ids: string;
    vendors_to_notify_ids: string;
    archived_from: string;
    sales_branch_name: string;
    assigned_to: string;
    focus: string;
}


export const mapCotationFromApi = (apiCotation: any): ICotation => ({
    ...apiCotation,
    created_at: mapDateFromApi(apiCotation.created_at),
    last_updated_at: apiCotation.last_updated_at ? mapDateFromApi(apiCotation.last_updated_at) : undefined
});
  
export const mapCotationPaginationFromApi = mapPaginationFromApi<ICotation>(mapCotationFromApi)



interface IAuthor{
    email: string;
    first_name: string;
    last_name: string;
    id: string;
}

export interface ICotationComment extends IEntity{
    id: string;
    author: IAuthor;
    message: string;
    publish_at: Date;
}

export const mapCotationCommentFromApi = (apiCotationComment: any): ICotationComment => ({
    ...apiCotationComment,
    publish_at: mapDateFromApi(apiCotationComment.publish_at)
});
  
export const mapCotationCommentPaginationFromApi = mapPaginationFromApi<ICotationComment>(mapCotationCommentFromApi)



// WEBPACK FOOTER //
// ./src/type/cotation.ts